import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from "@ngx-translate/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { NgForOf, NgStyle } from "@angular/common";
import { exerciceOrderByOptions } from "../../providers/exercices-provider";


@Component({
  selector: 'exercice-category-sorting',
  templateUrl: './exercice-category-sorting.html',
  styleUrls: ['./exercice-category-sorting.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    NgForOf,
    NgStyle,
  ],
})
export class ExerciceCategorySortingComponent  {
  @Output() onSortSelection = new EventEmitter<exerciceOrderByOptions>();

  @Input() selectedSort: exerciceOrderByOptions = exerciceOrderByOptions.name_asc;
  @Input() fullWidth: boolean = false;

  public sortingOptions: string[];

  constructor() {
    this.sortingOptions = Object.keys(exerciceOrderByOptions);
  }

  onSortSelectionChange(sort: string) {
    const option: exerciceOrderByOptions | undefined = Object.values(exerciceOrderByOptions)
      .find((option) => {
        return option === sort
      }
    );
    if (option) {
      this.onSortSelection.emit(option);
    }
  }
}
